import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Hero.module.sass";
import ScrollButton from "../../../components/ScrollButton";

const HeroEmargement = ({ scrollToRef }) => {
  return (
    <div className={styles.hero}>
      <div className={cn("container", styles.container)}>
        <div className={styles.col}>
          <div className={styles.preview}>
            {/* Main hero image */}
            <div className={styles.heroImage}>
              <img
                src="/images/content/emargement-illustration.png"
                alt="Contract Management Hero"
                className={styles.contractHero}
              />
            </div>
            
            {/* Animated CERFA background */}
            <div className={styles.cerfaBackground}>
              <img
                src="/images/content/Esign.png"
                alt="CERFA Document"
                className={styles.cerfaIllus}
              />
            </div>
            
            {/* Avatar in foreground */}
            <div className={styles.avatarForeground}>
              <img
                src="/images/content/AvatarRight.svg"
                alt="User Avatar"
                className={styles.avatarRight}
              />
            </div>
          
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.wrap}>
            <div className={cn("stage", styles.stage)}>
              Émargement - Assiduité
            </div>
            <h1 className={cn("h1", styles.title)}>
              Émargement, Edutio s'adapte à vous
            </h1>
            <div className={styles.text}>
              La signature des feuilles de présence en ligne est possible à distance et en présentiel. Edutio propose à vos centres de formation une réponse à chaque contexte et pour chaque appareil. Les solutions sont disponibles sur tout écran et sont sécurisées.
            </div>
            <div className={styles.btns}>
              <Link className={cn("button", styles.button)} to="/contact">
                Profiter d'un essai gratuit
              </Link>
              <Link
                className={cn("button-stroke", styles.button)}
                to="/contact"
              >
                Contact
              </Link>
            </div>
            <div className={styles.scrollWrapper}>
              <ScrollButton
                onScroll={() => {
                  if (scrollToRef && scrollToRef.current) {
                    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className={styles.scroll}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroEmargement;
